import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'reactstrap';
import BookCard from '../../components/bookcard';
import api from '../../service/api';
import BooksSkeleton from '../../shared/components/skeleton'
import { motion } from "framer-motion";
import { setWithExpiry, getWithExpiry } from '../../shared/localstorage';

const Books = () => {
   const [bookList, setBookList] = useState([]); 
   const [isLoading, setIsLoading] = useState(false);

   useEffect(() => {
        fetchBookList();
    }, [])

    const fetchBookList = () => {
        setBookList([]);
        setIsLoading(true);
        
        const cached = getWithExpiry('listBooks');
        if (cached) {
            const parsed = JSON.parse(cached);
            if (Array.isArray(parsed) && parsed.length > 0) {
                setBookList(parsed);
          
                setTimeout(() => {
                    setIsLoading(false);
                 }, "150");
            }
        } else {

              api.get(`/books`)
                .then((resp) => {
                    bindOnSucess(resp.data);
                })
                .finally(() => {
                    setIsLoading(false);
                });
        }
    };

    const bindOnSucess = (data) => {
        setBookList(data)
         try {
            setWithExpiry('listBooks', JSON.stringify(data), 3600000);
        } catch (e) {
            console.error('Failed to save listBooks to localStorage', e);
        }
    };

    return (
    <Container className="my-5">
        <Row className="justify-content-center align-items-center">
            <div className="mb-4">
              <motion.div
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                className="flex flex-col items-center mb-10"
                >

                <h1 className="text-center font-bold mb-5 text-white text-font-family">
                    Livros
                </h1>
                <div className="text-center text-color-site text-font-family">
                    <p className="lead">
                        Minha biblioteca pessoal: uma coleção de leituras diversas.
                    </p>
                </div>
            </motion.div>  
            </div>
          
           <Row className="g-3">
            {isLoading ? (
                <BooksSkeleton cardsCount={18}  />
             ) : (
                <React.Fragment>
                {bookList.map((book) => (
                   <Col key={book.id} xs="6" sm="4" md="3" lg="2">
                       <BookCard
                           title={book.title}
                           author={book.author}
                           coverUrl={book.coverUrl}
                       />
                   </Col>
                 ))}
                </React.Fragment>
            )}
            </Row> 
         </Row>
    </Container>)

}


export default Books